'use client';

import { useEffect } from 'react';

import { useHeaderVariant } from '@/shared/contexts/HeaderVariantContext';

export function useLNBOverlayReset() {
  const { setLNBOverlay } = useHeaderVariant();

  useEffect(() => {
    setLNBOverlay(false);
    return () => setLNBOverlay(null);
  }, [setLNBOverlay]);
}
